import ApiService from "@/core/services/ApiService";
import { defineStore } from "pinia";

export const useCmsStores = defineStore("cms", () => {
    // News
    async function getNews(params: any) {
        ApiService.setHeader();
        return await ApiService.query("news", params);
    }

    async function getNewsById(id: any) {
        ApiService.setHeader();
        return await ApiService.get(`news/${id}`);
    }

    async function deleteStatus(id: number) {
        ApiService.setHeader();
        return await ApiService.delete(`news/${id}`);
    }

    async function getRules(params: any) {
        ApiService.setHeader();
        return await ApiService.query("rules", params);
    }

    async function getRulesCategory(params : any) {
        ApiService.setHeader();
        return await ApiService.query("rules/category",params);
    }

    async function getRulesById(id: any) {
        ApiService.setHeader();
        return await ApiService.get(`rules/${id}`);
    }

    async function deleteRules(id: number) {
        ApiService.setHeader();
        return await ApiService.delete(`rules/${id}`);
    }

    async function getGallery(params: any) {
        ApiService.setHeader();
        return await ApiService.query("gallery", params);
    }

    async function getGalleryById(id: any) {
        ApiService.setHeader();
        return await ApiService.get(`gallery/${id}`);
    }

    async function deleteGallery(id: number) {
        ApiService.setHeader();
        return await ApiService.delete(`gallery/${id}`);
    }

    async function deleteChildGallery(id: number) {
        ApiService.setHeader();
        return await ApiService.delete(`gallery/children/${id}`);
    }

    async function getAboutUs() {
        ApiService.setHeader();
        return await ApiService.get("information/about-us");
    }

    async function getSocialMedia(params: any) {
        ApiService.setHeader();
        return await ApiService.query("information/social-media", params);
    }

    async function getContactInformation() {
        ApiService.setHeader();
        return await ApiService.get("information/contact-information");
    }

    async function getHomeSlider() {
        ApiService.setHeader();
        const params: any = {
            status: 'active'
        };
        return await ApiService.query("information/home-slider", params);
    }

    async function getSpklu(params: any) {
        params.status = 1;
        ApiService.setHeader();
        return await ApiService.query("cms/spklu", params);
    }

    async function getFaqList(params:any) {
        ApiService.setHeader();
        return await ApiService.query("faq", params);
    }

    async function postFaq(payload: any) {
        ApiService.setHeader();
        return await ApiService.post("contact-us", payload);
    }

    async function getOwnerSpklu(params: any) {
        ApiService.setHeader();
        return await ApiService.query("master-data/owner-spklu", params);
    }

    async function getStatistik() {
        ApiService.setHeader();
        return await ApiService.get("dashboard/statistik");
    }

    async function getSumSuket() {
        ApiService.setHeader();
        return await ApiService.get(`dashboard/get-sum-suket`);
    }

    async function getDetailPltd() {
        ApiService.setHeader();
        return await ApiService.get(`dashboard/get-detail-pltd`);
    }

    async function getChartPltd() {
        ApiService.setHeader();
        return await ApiService.get(`dashboard/get-chart-pltd`);
    }

    async function getChartPlts() {
        ApiService.setHeader();
        return await ApiService.get(`dashboard/get-chart-plts`);
    }

    return {
        getNews,
        deleteStatus,
        getRules,
        getRulesCategory,
        deleteRules,
        getGallery,
        deleteGallery,
        getNewsById,
        getRulesById,
        getGalleryById,
        deleteChildGallery,
        getAboutUs,
        getSocialMedia,
        getContactInformation,
        getHomeSlider,
        getSpklu,
        getFaqList,
        postFaq,
        getOwnerSpklu,
        getStatistik,
        getSumSuket,
        getDetailPltd,
        getChartPltd,
        getChartPlts
    };

});


